module.exports = __webpack_public_path__ + "static/media/Internationalpic3.41576617.png";